import { FC, ReactElement, useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
// import { useDispatch } from 'react-redux';
import { useLanguage } from 'state/base/hooks';

interface Props {
    onClose: () => void;
}

const LangeComponents: FC<Props> = ({ onClose }): ReactElement => {
    const { i18n } = useTranslation();
    // const dispatch = useDispatch();
    const [, setLanguage] = useLanguage();
    const [activeLange, setActiveLange] = useState<string>(window.localStorage.getItem('lange') ?? 'zh_CN');
    const langeList = [
        { key: 'en_US', title: 'English' },
        { key: 'zh_CN', title: '简体中文' },
        { key: 'zh_HK', title: '繁体中文' },
        // {key: 'en_US', title: '한국인'},
        // {key: 'en_US', title: '日本语'},
        // {key: 'en_US', title: 'Русский'}
    ];
    console.log(setActiveLange);
    const setLange = (lange): void => {
        i18n.changeLanguage(lange);
        setLanguage(lange);
        // dispatch(setLanguage(lange));
        // window.localStorage.setItem('lange', lange);
        onClose();
    };

    return (
        <LangeModal>
            {langeList.map(item => (
                <LangeItem key={item.key} className={item.key === activeLange ? '_active' : ''} onClick={() => setLange(item.key)}>
                    {item.title}
                </LangeItem>
            ))}
        </LangeModal>
    );
};

const LangeModal = styled.div`
    border-radius: 0.1rem;
    border: 0.04rem solid #fff;
    padding: 0.08rem 0;
    background: rgba(255, 255, 255, 1);
    position: absolute;
    top: 0.46rem;
    right: 0.1rem;
    z-index: 9;
`;
const LangeItem = styled.p`
    font-size: 0.12rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #000000;
    opacity: 0.6;
    line-height: 0.32rem;
    width: 0.8rem;
    cursor: pointer;
    text-align: center;
    &._active {
        color: #21212f;
        opacity: 1;
    }
`;

export default LangeComponents;
